import React from 'react';
import { connect } from 'react-redux';
import NotFoundPage from '../NotFoundPage';
import * as actions from '../../../actions/events';
import Loader from '../../common/Loader.js';
import ErrorMessage from '../../common/ErrorMessage';
import Layout from '../Layout';
import Error504 from '../../common/Error504';
import Error503 from '../../common/Error503';
import { getCurrentDate } from '../../../utils/dateFormatter';

import LeaderBoard from './LeaderBoard';

class EventsPage extends React.Component {
  /**
   * [constructor description]
   * @param  {Object} props [description]
   */
  constructor(props) {
    super(props);
    this.handleDaySelection = this.handleDaySelection.bind(this);
  }

  /**
   * [handleDaySelection description]
   * @param  {Number} data [selected date number] [dispatches eventsData action and get latest data]
   */
  handleDaySelection(data) {
    console.log('000', data);
    this.props.eventsData(`${data}`);
  }

  componentDidMount() {
    this.props.eventsData(getCurrentDate().dateNumber);
    // update store after every 30 minutes
    window.setInterval(() => {
      this.props.eventsData(getCurrentDate().dateNumber);
    }, 1800000);
  }

  render() {
    return (
      <Layout>
        <div className="main-view">
          <Loader name="quick-view-loader" />
          {this.props.eventData && this.props.eventData.data ? (
            <LeaderBoard
              eventsData={this.props.eventData.data}
              daySelectionHandler={this.handleDaySelection}
              selectedDate={this.props.eventData.selectedDate}
              isShowWinners={this.props.eventData.showWinners}
              nextUpdateTime={this.props.eventData.nextUpdateTime}
              winnersList={this.props.eventData.winnersList}
            />
          ) : (
            <Loader name="quick-view-loader" />
          )}
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { httpError = {} } = state;
  const errorHttp = httpError.leaderBoard;
  return {
    eventData: state.events,
    error: state.error,
    errorHttp
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    eventsData: data => dispatch(actions.getEventsData(data))
  };
};

export default EventsPage = connect(mapStateToProps, mapDispatchToProps)(EventsPage);
